// extracted by css-extract-rspack-plugin
export default {"root":"Zkt7vLENr50f5xSS"};